import React from 'react';
import cx from 'classnames';
import styles from './ToastNotification.module.scss';
import type { ToastNotificationProps } from './ToastNotification.types';
import { WrapTextNodes } from '../../utils/WrapTextNodes';
import useBuildVariantProps from '../../../modules/theme/useBuildVariantProps';
import IconButton from '../IconButton';
import Icon from '../Icon';

const ToastNotification: React.FC<ToastNotificationProps> = (props) => {
  const {
    className,
    style = 'Neutral',
    leadingIcon,
    trailingIcon,
    closeIcon,
    isDismissable = true,
    isCloseButtonShown = true,
    removeToast,
    duration,
    renderContent,
    children,
    ...restProps
  } = props;

  if (renderContent && typeof renderContent === 'function') {
    return <>{renderContent({ removeToast: removeToast ?? (() => { }) })}</>;
  }

  let leadingIconComponent, trailingIconComponent, content, closeIconComponent;

  if (leadingIcon) {
    leadingIconComponent = <>{leadingIcon}</>;
  }

  if (trailingIcon) {
    trailingIconComponent = <>{trailingIcon}</>;
  }

  if (isDismissable && isCloseButtonShown) {
    closeIconComponent = (
      <IconButton
        type='Ghost'
        style='Secondary'
        appearance='Default'
        icon={closeIcon || <Icon icon='CloseDelete' style='Outlined' />}
        onClick={removeToast}
      />
    );
  }

  if (children) {
    content = (
      <WrapTextNodes className={styles.text}>
        {children}
      </WrapTextNodes>
    );
  }

  const variantProps = useBuildVariantProps(
    'toast-notification',
    { style },
    {}
  );

  return (
    <div
      className={cx(styles.toastNotification, className)}
      {...variantProps}
      {...restProps}
    >
      <div className={styles.messageContainer}>
        {leadingIconComponent}
        {content}
        {trailingIconComponent}
      </div>
      {closeIconComponent}
    </div>
  );
};

export default ToastNotification;
